// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36UEu","controls":"styles_controls__2eLw3","charLimit":"styles_charLimit__3wRhJ","input":"styles_input__1C4eh","send":"styles_send__2ZLX7"};